import { useEffect } from 'react';
import { useRef } from 'react';
/**
 * @function useWatch
 * @since 1.0.0
 */
export function useWatch(effect, deps) {
    const mounted = useRef(false);
    useEffect(() => {
        if (mounted.current == false) {
            mounted.current = true;
            return;
        }
        effect();
    }, deps);
}
